import React from "react";
import './serviceItem.css';
import Footer from "../components/footer";
import { Helmet } from "react-helmet";
import Banner from "../components/banner";
import IconCard from "../components/iconCard";
import LetsCode from "../components/letscode";
import Serviceform from "../components/serviceform";
const customSoftwareDevelopment = `/images/icons/custom-software-development.png`;
const eCommerceDevelopment = `/images/ecommerce-developemt.png`;
const appMobile = `/images/app-mobile.png`;
const aspImage = `/images/icons/asp.svg`;
const nodeImage = `/images/icons/node.svg`;
const angularImage = `/images/icons/angular.svg`;
const reactImage = `/images/icons/react.svg`;
const pythonImage = `/images/icons/python.svg`;
const javaImage = `/images/icons/java.svg`;
const phpImage = `/images/icons/php.svg`;
const vueImage = `/images/icons/vue.svg`;
const deg = `/images/clients/66deg-client.png`;
const cabi = `/images/clients/cabi.png`;
const scadea = `/images/clients/scadea-client.png`;
const techolution = `/images/clients/techolution-client.png`;
const proIt = `/images/clients/pro-it.png`;
const nextLoop = `/images/clients/next-loop.png`;

const industry15 = `/images/icons/15-years-in-industry.png`;
const sourceCode = `/images/icons/source-code-delivery-to-clients.png`;
const microsoftAzure = `/images/icons/microsoft-365-azure.png`;
const response24 = `/images/icons/less-than-24-hrs-guaranteed-response.png`;
const certifiedDevelopers = `/images/icons/certified-developers.png`;
const projectManager = `/images/icons/dedicated-project-manager.png`;
const client = `/images/icons/clients-usa-uk-australia.png`;
const tightDeadlines = `/images/icons/handle-tight-deadlines.png`;

const featuresEcommerce = [
    {
        title: 'Creation Of E-commerce Sites',
        description: "We create custom e-commerce websites that are visually appealing and user-friendly, designed to convert visitors into loyal customers. Our team combines innovative design with powerful functionality to help your business thrive online. As experts in ecommerce website development services, we ensure a seamless experience for every customer."
    },
    {
        title: 'Generate Online Sales',
        description: "We focus on implementing targeted strategies that boost your online sales. From optimizing product listings to leveraging data-driven marketing techniques, we help you attract and retain customers, ensuring sustainable growth for your e-commerce business."
    },
  ]

  const bannerDetails =
  {
      title: 'Our Services',
      subTitle: 'E Commerce Development',
      description: "We specialize in crafting robust e-commerce solutions that enhance user engagement and drive sales. As a top ecommerce development agency, we focus on creating the best e-commerce platforms for businesses to thrive online.",
      buttonText : 'Work with Us',
      button: true
  }

function ECommerceDevelopment() {

    return(
      
<>
<Helmet>
   <meta name="description" content="We offer custom ecommerce website design and development services, and we create any universal and unique features needed for smooth customer journeys."/>
   <meta name="keywords" content="E-Commerce Development Services, E-Commerce Development Service in Noida, Online Store Development in Noida, E-Commerce Development Company"/>
   <title>E-Commerce Website Design & Development Services - Stamens Software</title>
</Helmet>

    <Banner details={bannerDetails} />

<section className="our-fetaures">
    <div className="container">
        <div className="row justify-content-center gy-4">
        {featuresEcommerce.map((card, index) => (
                <IconCard key={index} cardProps={card} parentChildClass={'part'} parentClass={'col-lg-6 col-md-6'} iconClass={'bi bi-database'} paraClass={'small-head'} childClassA={'icon'} childClassB={'content'} />
            ))}
        </div>
    </div>
</section>

<section className="welcome">
    <div className="container">
        <div className="row justify-content-center gy-4">
            <div className="col-lg-7 col-md-7">
                <div className="content">
                    <h2 className="head"><span>Welcome to Stamens</span>
                        Discover the power of E-commerce website
                    </h2>
                    <p>We specialize in creating dynamic and user-friendly <b>e-commerce websites</b> that drive sales and enhance customer experiences. Our experts of E-Commerce Development Services in Noida utilizes the latest technologies to build scalable solutions tailored to your business needs, ensuring a seamless online shopping journey for your customers.</p>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="part">
                                <div className="icon">
                                    <img src={customSoftwareDevelopment} alt="icon 1" className="img-fluid" />
                                </div>
                                <div className="part-content">
                                    <p className="small-head">Boost Your Online Sales</p>
                                    <p>Boost your revenue with a robust <b>e-commerce platform </b>designed to attract and retain customers. Our development process focuses on optimizing conversion rates and enhancing user engagement, helping you turn visitors into loyal buyers.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="part">
                                <div className="icon">
                                    <img src={customSoftwareDevelopment} alt="icon 2" className="img-fluid" />
                                </div>
                                <div className="part-content">
                                    <p className="small-head">Custom Solutions for Every Business</p>
                                    <p>No two businesses are the same, and neither should their e-commerce solutions be. We provide tailored development services that align with your unique business goals, ensuring a personalized approach that sets you apart in the competitive online marketplace.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-5 col-md-5">
                <div className="right-image h-100 d-flex align-items-center justify-content-center">
                    <img src={eCommerceDevelopment} alt="ecommerce" className="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section className="work-process">
    <div className="container">
        <h2 className="head"><span>Welcome to Stamens</span>
            How it is going?
        </h2>
        <div className="row justify-content-around gy-4">
            <div className="col-lg-4">
                <div className="part">
                    <p className="small-head">Discovery & Planning</p>
                    <p>We start by understanding your business needs and goals to create a tailored <b>e-commerce strategy.</b></p>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="part">
                    <p className="small-head">Design & Development</p>
                    <p>Our team crafts a user-friendly interface and robust backend systems to ensure a seamless shopping experience.</p>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="part">
                    <p className="small-head">Integration</p>
                    <p>We integrate essential tools and platforms to streamline operations and enhance functionality.</p>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="part">
                    <p className="small-head">Testing & Launch</p>
                    <p>Rigorous testing ensures everything works flawlessly before your online store goes live.</p>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="part">
                    <p className="small-head">Ongoing Support</p>
                    <p>After launch, we provide continuous support and updates to help your business adapt and thrive.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<LetsCode content={"Get in touch with our expert e-commerce developers to receive top-tier custom e-commerce website development services and the best design solutions for your online business"}/>

<section className="technologie">
    <div className="container">
        <h3 className="head">
            <span>Our Technologies</span>
            All Technologies Software in stamens
        </h3>
        <div className="row gy-4">
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <img src={aspImage} alt="asp" className="img-fluid" />
                    <h4>.Net</h4>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <img src={nodeImage} alt="node" className="img-fluid" />
                    <h4>Node JS</h4>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <img src={angularImage} alt="angular" className="img-fluid" />
                    <h4>Angular JS</h4>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <img src={reactImage} alt="react" className="img-fluid" />
                    <h4>React JS</h4>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <img src={pythonImage} alt="python" className="img-fluid" />
                    <h4>Python</h4>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <img src={javaImage} alt="java" className="img-fluid" />
                    <h4>Java</h4>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <img src={phpImage} alt="php" className="img-fluid" />
                    <h4>PHP</h4>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <img src={vueImage} alt="vue" className="img-fluid" />
                    <h4>Vue JS</h4>
                </div>
            </div>
        </div>
    </div>
</section>

<section className="app-mobile">
    <div className="container">
        <div className="row d-flex align-items-center">
            <div className="col-md-4">
                <img src={appMobile} alt="app-mobile" className="img-fluid" />
            </div>
            <div className="col-md-8">
                <h3 className="head"> Partner with our client-centered team for top-quality software solutions </h3>
                <p>Our team of skilled developers has years of experience in creating custom <b>e-commerce websites</b> for a range of platforms, including iOS, Android, and Windows. We utilize the latest tools and technologies to ensure that our <b>e-commerce websites</b> are optimized for performance, security, and seamless usability.</p>
                <p>We specialize in crafting intuitive <b>iOS e-commerce applications</b> that provide a top-notch shopping experience for iPhone and iPad users. Our <b>Android e-commerce apps</b> are designed to perform exceptionally across a wide range of devices, ensuring an optimized user experience for your customers.</p>
                <p>Using frameworks like <b>Flutter and React Native</b>, we build efficient that work seamlessly across both iOS and Android platforms. Our design team in E-Commerce Development Company in India focuses on creating visually stunning, user-centered e-commerce interfaces that engage users and enhance usability, leading to higher conversion rates and customer satisfaction.</p>            
            </div>
        </div>
    </div>
</section>

<section className="our-company-sec-mobile">
    <div className="container">
        <h4 className="head"><span>Why Stamens Software</span>We are one of the best IT companies?</h4>
        <div className="row gy-4">
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <div className="icon"><img src={industry15} alt="Custom Software Development" className="img-fluid" /></div>
                    <p>15+ Years in Industry</p>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <div className="icon"><img src={sourceCode} alt="Custom Software Development" className="img-fluid" /></div>
                    <p>Source Code Delivery to Clients</p>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <div className="icon"><img src={microsoftAzure} alt="Custom Software Development" className="img-fluid" /></div>
                    <p>Microsoft 365, Azure</p>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <div className="icon"><img src={response24} alt="Custom Software Development" className="img-fluid" /></div>
                    <p>Less than 24 hrs Guaranteed Response</p>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <div className="icon"><img src={certifiedDevelopers} alt="Custom Software Development" className="img-fluid" /></div>
                    <p>Certified Developers</p>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <div className="icon"><img src={projectManager} alt="Custom Software Development" className="img-fluid" /></div>
                    <p>Dedicated Project Manager</p>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <div className="icon"><img src={client} alt="Custom Software Development" className="img-fluid" /></div>
                    <p>Clients: USA, UK, Australia, etc.</p>
                </div>
            </div>
            <div className="col-lg-3 col-md-4">
                <div className="icons">
                    <div className="icon"><img src={tightDeadlines} alt="Custom Software Development" className="img-fluid" /></div>
                    <p>Handle Tight Deadlines</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section className="trusted">
    <div className="container">
        <div className="text-center">
            <h4 className="head"><span>Trusted Companies</span> Trusted by many companies</h4>
            <p className="tagline col-md-9 mx-auto text-center fs-5 mb-5 d-block">Our commitment to quality and performance has earned us the trust of top brands, empowering them to deliver exceptional user experiences and achieve their business goals. Join a network of successful companies that leverage our technology to enhance their app development processes.</p>
        </div>
        <div className="images">
            <img src={deg} alt="66deg" className="img-fluid" height="103" width="237" />
            <img src={cabi} alt="cabi" className="img-fluid" height="103" width="237" />
            <img src={proIt} alt="Pro IT" className="img-fluid" height="103" width="237" />
            <img src={scadea} alt="scadea" className="img-fluid" height="103" width="237" />
            <img src={techolution} alt="techolution" className="img-fluid" height="103" width="237" />
            <img src={nextLoop} alt="next-loop" className="img-fluid" height="103" width="237" />
        </div>
    </div>
</section>  
<Serviceform about={"Get in Touch with Stamens Experts of E-commerce Development Services!"}/>
<Footer />
</>

    )

}

export default ECommerceDevelopment;